// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"c6c7c627","591":"3e4b4721","787":"e3142c18","801":"791a5b7c","977":"66ddfab1"}[chunkId] + ".chunk.js";
};